import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15 5a2 2 0 0 0-2 2v10a4 4 0 0 1-8 0v-6a1 1 0 1 1 2 0v6a2 2 0 1 0 4 0V7a4 4 0 0 1 8 0v5a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.864 3.48a1 1 0 0 0-1.728 0L3.377 6.497A1 1 0 0 0 4.241 8h3.518a1 1 0 0 0 .864-1.504zM15 18a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
    }, null, -1)
  ])))
}
export default { render: render }